export function deviceDependentConfigurationTypeGuard(configuration) {
    return (typeof configuration === 'object' && !!configuration && 'mobile' in configuration && 'desktop' in configuration);
}
export function getAdaptiveConfigurationValue(configuration) {
    if (deviceDependentConfigurationTypeGuard(configuration)) {
        return configuration[getDeviceType()];
    }
    else {
        return configuration;
    }
}
export function getDeviceType() {
    const query = window.matchMedia('only screen and (max-width: 600px)');
    const isMobile = query && query.matches;
    return isMobile ? 'mobile' : 'desktop';
}
//# sourceMappingURL=AdaptiveConfigurationDto.js.map